/**
 * 正则校验邮箱
 * @param {string} value
 * @returns {Boolean}
*/
export function checkEmail(value) {
  return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value)
}
/**
 * 正则验证数字下划线英文
 * @param {string} value
 * @returns {Boolean}
*/
export function checkStoreLink(value) {
  return /^(?![-_])(?!.*?[-_]$)[A-Za-z0-9-_]+$/.test(value)
}
/**
 * 正则验证纯数字
 * @param {string} value
 * @returns {Boolean}
*/
export function pureNumber(value) {
  return /^[0-9]*$/.test(value)
}
/**
 * 正则验证手机号
 * @param {string} value
 * @returns {Boolean}
*/
export function telephoneNumber(value) {
  return /^\+?\d+(?:[\s-]\d+)*$/.test(value)
}
/**
 * 正则验证（国外手机号）
 * @param {string} value
 * @returns {Boolean}
*/
export function generalPhoneNumber(value) {
  return /^\(?(\d{3})\)?[-\. ]?(\d{3})[-\. ]?(\d{4})$/.test(value)
}
/**
 * 正则验证1-9999999
 * @param {string} value
 * @returns {Boolean}
*/
export function amount(value) {
  return /^(9999999|((?!9999999)[0-9][0-9]{0,6})(\.[0-9]{0,2})?)$/.test(value)
}

/**
 * 正则验证6位数字
 * @param {string} value
 * @returns {Boolean}
*/
export function sixNumber(value) {
  return /^\d{6}$/.test(value)
}

/**
 * 正则验证欧盟及英美加拿大邮编验证
 * @param {string} value
 * @returns {Boolean}
*/
export function isValidPostalCode(value, countryCode) {
  let postalCodeRegex
  switch (countryCode) {
    case 'US':
      postalCodeRegex = /^\d{5}([ \-]\d{4})?$/
      break
    case 'CA':
      postalCodeRegex = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/
      break
    case 'GB':
      postalCodeRegex = /^([A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKS-UW])\ [0-9][ABD-HJLNP-UW-Z]{2}|(GIR\ 0AA)|(SAN\ TA1)|(BFPO\ (C\/O\ )?[0-9]{1,4})|((ASCN|BBND|[BFS]IQQ|PCRN|STHL|TDCU|TKCA)\ 1ZZ))$/
      break
    case 'AT':
      postalCodeRegex = /^\d{4}$/
      break
    case 'BE':
      postalCodeRegex = /^\d{4}$/
      break
    case 'BG':
      postalCodeRegex = /^\d{4}$/
      break
    case 'CY':
      postalCodeRegex = /^\d{4}$/
      break
    case 'HR':
      postalCodeRegex = /^\d{5}$/
      break
    case 'CZ':
      postalCodeRegex = /^\d{3}[ ]?\d{2}$/
      break
    case 'DK':
      postalCodeRegex = /^\d{4}?$/
      break
    case 'EE':
      postalCodeRegex = /^\d{5}$/
      break
    case 'FI':
      postalCodeRegex = /^\d{5}$/
      break
    case 'FR':
      postalCodeRegex = /^\d{5}$/
      break
    case 'DE':
      postalCodeRegex = /^\d{4,5}$/
      break
    case 'GR':
      postalCodeRegex = /^\d{3}[ ]?\d{2}$/
      break
    case 'HU':
      postalCodeRegex = /^\d{4}$/
      break
    case 'IT':
      postalCodeRegex = /^\d{2,5}$/
      break
    case 'LV':
      postalCodeRegex = /^(?:LV-)*(\d{4})$/
      break
    case 'LT':
      postalCodeRegex = /^\d{5}$/
      break
    case 'LU':
      postalCodeRegex = /^(?:L-)*\d{3,4}$/
      break
    case 'MT':
      postalCodeRegex = /^[A-Z]{3}[ ]?\d{2,4}$/
      break
    case 'NL':
      postalCodeRegex = /^\d{4}[ ]?[A-Z]{2}$/
      break
    case 'PL':
      postalCodeRegex = /^\d{2}-\d{3}$/
      break
    case 'PT':
      postalCodeRegex = /^\d{4}([\-]\d{3})?$/
      break
    case 'RO':
      postalCodeRegex = /^\d{6}$/
      break
    case 'SK':
      postalCodeRegex = /^\d{3}[ ]?\d{2}$/
      break
    case 'SI':
      postalCodeRegex = /^\d{4}$/
      break
    case 'ES':
      postalCodeRegex = /^\d{4,5}$/
      break
    case 'SE':
      postalCodeRegex = /^\d{3}[ ]?\d{2}$/
      break
    default:
      postalCodeRegex = /^(?:[A-Za-z0-9]+([- ]?[A-Za-z0-9]+)*)?$/
  }
  return postalCodeRegex.test(value)
}

/**
 * 验证是否是有效的URL
 *
 * @param {string} url
 * @returns {Boolean}
 */
export function validateURL(url) {
  let reg = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
  return reg.test(url)
}

// 判断是否含有大写字母
export function hasCapital(str) {
  var result = str.match(/^.*[A-Z]+.*$/)
  if (result === null) return false
  return true
}

// 判断是否含有小写字母
export function hasLowercase(str) {
  var result = str.match(/^.*[a-z]+.*$/)
  if (result === null) return false
  return true
}

// 判断是否含有数字
export function hasNumber(str) {
  var result = str.match(/^.*[0-9]+.*$/)
  if (result === null) return false
  return true
}
